import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import { Button } from 'uikit/buttons';

import styles from '../styles/quill.module.scss';

const QuillSubmitButton = ({ onClick }) => (
  <Button
    className={styles.submit}
    color="primary"
    size="large"
    onClick={onClick}
    text={i18n.t('send')}
  />
);

QuillSubmitButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default QuillSubmitButton;
